import { FC } from "react";

import Select from "../../custom/select/select";

import styles from "../headerBtn.module.scss";

const deliveryStatusesOptions = [
  { value: "OnTime", label: "Вовремя" },
  { value: "Expired", label: "Просрочен" },
  { value: "Manual", label: "Создан" },
];

interface IStatusOptions {
  setSelectedOption: (el: string) => void;
}

const UpdateDeliveryStatusSection: FC<IStatusOptions> = ({ setSelectedOption }) => {
  const handleSelecteChange = (event: {value: string, label: string}) => {
    setSelectedOption(event.value);
  };

  return (
    <div className={styles.block__info}>
      <div className={styles.limit__block}>
        <span>Статус:</span>
        <Select
          className={styles.photo__select}
          defaultValue={deliveryStatusesOptions[0]}
          propsChange={(event: {value: string, label: string}) => handleSelecteChange(event)}
          options={deliveryStatusesOptions}
        />
      </div>
    </div>
  );
};

export default UpdateDeliveryStatusSection;
